
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"32","height":"32","preserveAspectRatio":"xMidYMid meet"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#003653","fill-rule":"evenodd","d":"M26 8a2 2 0 012 2v12a2 2 0 01-2 2H6a2 2 0 01-2-2V10a2 2 0 012-2h20zm0 1H6a1 1 0 00-.993.883L5 10v12a1 1 0 00.883.993L6 23h20a1 1 0 00.993-.883L27 22V10a1 1 0 00-.883-.993L26 9zm-7 1a2 2 0 012 2v8a2 2 0 01-2 2H8a2 2 0 01-2-2v-8a2 2 0 012-2h11zm0 1H8a1 1 0 00-.993.883L7 12v8a1 1 0 00.883.993L8 21h11a1 1 0 00.993-.883L20 20v-8a1 1 0 00-.883-.993L19 11zm3.75 8.5a.75.75 0 110 1.5.75.75 0 010-1.5zm2.5 0a.75.75 0 110 1.5.75.75 0 010-1.5zm-12.743-6.387c.2.157.21.42.021.587-.95.84-.414 1.768-.01 2.246.482.571.606 1.208.356 1.84-.243.616-.808 1.11-1.105 1.193a.591.591 0 01-.158.021c-.209 0-.403-.11-.473-.284-.079-.197.03-.41.245-.501.1-.066.5-.404.598-.868.068-.319-.024-.621-.28-.923-.97-1.148-.932-2.38.1-3.293a.571.571 0 01.706-.018zm3 0c.2.157.21.42.021.587-.95.84-.414 1.768-.01 2.246.482.571.606 1.208.356 1.84-.243.616-.808 1.11-1.105 1.193a.591.591 0 01-.158.021c-.209 0-.403-.11-.473-.284-.079-.197.03-.41.245-.501.1-.066.5-.404.598-.868.068-.319-.024-.621-.28-.923-.97-1.148-.932-2.38.1-3.293a.571.571 0 01.706-.018zM22.75 17a.75.75 0 110 1.5.75.75 0 010-1.5zm2.5 0a.75.75 0 110 1.5.75.75 0 010-1.5zM24 11a2 2 0 110 4 2 2 0 010-4zm.692 1.278l-1.333 1.49S23.756 14 24 14a1 1 0 001-1c0-.284-.308-.722-.308-.722z"}})])
          )
        }
      }
    